import React, { useEffect, useState } from 'react';
import { upload } from '../Users';
import imageCompression from 'browser-image-compression';

export default function FileUpload(props) {
    const { group, setGroup, type, input, setInput } = props;
    const [message, setMessage] = useState('');
    const [compressionSize, setCompressionSize] = useState(600); // To store the selected compression option

    useEffect(() => {
        if (type==="pfp") {
            setCompressionSize(300)
        } else if (type === "background") {
            setCompressionSize(1920)
        }
    }, [type])

    // Handle file upload to the backend
    async function handleUpload(event) {
        const selectedFile = event.target.files[0];
        console.log('Selected file:', selectedFile);
        console.log('File type:', selectedFile.type);

        if (!selectedFile) {
            setMessage('No file selected!');
            return;
        }

        let compressedFile = selectedFile;

        // Perform image compression if the file type is "image" and compression size is selected
        if ((type === 'image' || type === "pfp" || type === "background") && compressionSize) {
            const options = {
                maxWidthOrHeight: compressionSize, // Apply the selected compression size
                useWebWorker: true,
            };
            try {
                compressedFile = await imageCompression(selectedFile, options);
                console.log('File compressed successfully');
            } catch (error) {
                console.error('Error during image compression:', error);
            }
        }

        if (compressedFile.size > 20 * 1024 * 1024) {
            setMessage("File too large! Please upload files under 20MB. Ideally significantly less than that.");
            return;
        }

        const formData = new FormData();
        formData.append('file', compressedFile);

        try {
            setMessage('Uploading...');
            const response = await upload(formData);

            if (response) {
                setMessage('Upload successful!');
                const uploadedImageUrl = `https://willow-web.s3.eu-west-2.amazonaws.com/${response.filePath}`;
                if (type==="pfp") {
                    setInput((prev) => ({...prev, pfp: uploadedImageUrl}))
                } if (type==="background") {
                    setInput((prev) => ({...prev, backgroundImage: uploadedImageUrl}))
                } else {
                    setGroup((prev) => ({ ...prev, blockContent: uploadedImageUrl }));
                }
                
            } else {
                setMessage('Upload failed.');
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            if (type !== "pfp") {
                setMessage('Error uploading file.');
            }
        }
    }

    return (
        <div>
            {(type === 'pfp' || type === 'background') &&
            (input?.pfp || input?.backgroundImage) && (
                <div id={type==='pfp' ? "settings-pfp-img" : 'skin-background-image'}>
                    <img
                        src={input.pfp? input.pfp : input.backgroundImage}
                        alt="preview"
                    />
                </div>
            )}
            {type === 'image' && (
                <div>
                    <label className="radio-container">Compress to 600x600px
                        <input
                            type="radio"
                            value={600}
                            checked={compressionSize === 600}
                            onChange={() => setCompressionSize(600)}
                        />
                        <span className="radio"/>
                    </label>
                    <label className="radio-container">Compress to 900x900px
                        <input
                            type="radio"
                            value={900}
                            checked={compressionSize === 900}
                            onChange={() => setCompressionSize(900)}
                        />
                        <span className="radio"/>
                    </label>
                    <label className="radio-container">Compress to 1200x1200px
                        <input
                            type="radio"
                            value={1200}
                            checked={compressionSize === 1200}
                            onChange={() => setCompressionSize(1200)}
                        />
                        <span className="radio"/>
                    </label>
                    <label className="radio-container">No compression (avoid where possible)
                        <input
                            type="radio"
                            value={null}
                            checked={compressionSize === null}
                            onChange={() => setCompressionSize(null)}
                        />
                        <span className="radio"/>
                    </label>
                </div>
            )}

            <input type="button" id="loadFileXml" value="file upload" onClick={() => document.getElementById('file-upload').click()} className={"settings-file-upload"} style={{width: "120px"}}/>

            <input className={type === 'pfp'? "settings-file-upload" : ""}
                id="file-upload"
                type="file"
                name="file"
                style={{display:"none"}}
                accept={
                    type === 'pdf'
                        ? 'application/pdf'
                        : type === 'audio'
                        ? 'audio/*'
                        : 'image/*'
                }
                onChange={handleUpload}
            />
            
            {(type === 'image') &&
            (group?.blockContent) && (
                <div>
                    <img
                        src={group.blockContent}
                        alt="preview"
                        style={{ maxWidth: '200px', height: 'auto', marginTop: "10px" }}
                    />
                </div>
            )}
            {message && <p>{message}</p>}
        </div>
    );
}